import { ThemeProvider, useTheme } from '@emotion/react';
import { Box, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { ImageInput } from 'app/shared/components/image-input/ImageInput';
import { BoxForm, FormControlDefault, TextFieldForms, TypographyForms } from 'app/shared/layout/register/DefaultFormsComponents';
import { RegisterButton } from 'app/shared/layout/register/RegisterButton';
import { RegisterLayout } from 'app/shared/layout/register/RegisterLayout';
import { RegisterTitle } from 'app/shared/layout/register/RegisterTitle';
import React, { useEffect, useState } from 'react';
import { translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';
import { createEntity, getEntity, reset, updateEntity } from './gas-supply.reducer';

export const GasSupplyUpdate = (props: RouteComponentProps<{ id: string; schedulingId: string }>) => {
  const dispatch = useAppDispatch();
  const [isNew] = useState(!props.match.params || !props.match.params.id);
  const schedulingId = props?.match?.params?.schedulingId || '';
  const gasSupplyEntity = useAppSelector(state => state.gasSupply.entity);
  const loading = useAppSelector(state => state.gasSupply.loading);
  const updateSuccess = useAppSelector(state => state.gasSupply.updateSuccess);
  const [formData, setFormData] = useState({
    volume: '',
    price: '',
    distance: '',
    image: '',
    imageContentType: '',
  });
  const handleClose = () => {
    props.history.push(`/gas-supplies/scheduling/${schedulingId}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (!isNew && gasSupplyEntity) {
      setFormData({
        volume: gasSupplyEntity?.volume,
        price: gasSupplyEntity?.price,
        distance: gasSupplyEntity?.distance,
        image: gasSupplyEntity?.image,
        imageContentType: gasSupplyEntity?.imageContentType,
      });
    }
  }, [gasSupplyEntity]);

  const handleInputChange = (fieldName, value) => {
    setFormData({ ...formData, [fieldName]: value });
  };

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...gasSupplyEntity,
      ...values,
      schedulingId,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const handleSubmit = () => {
    event.preventDefault();
    saveEntity(formData);
  };

  const theme = useTheme();
  return (
    <>
      <ThemeProvider theme={theme}>
        <RegisterLayout>
          <Box sx={{ width: { xs: '95%', sm: '70%', lg: '50%' } }} justifyContent={'center'}>
            <RegisterTitle isNew={isNew} contentKey={'fleetSenseApp.gasSupply'} />
            <Box>
              {loading ? (
                <Box>
                  <Typography>Loading...</Typography>
                </Box>
              ) : (
                <Box margin={'0 auto'} width={'100%'}>
                  <BoxForm onSubmit={handleSubmit}>
                    {!isNew && (
                      <FormControlDefault sx={{ display: 'none' }}>
                        <TypographyForms>{translate('global.field.id')}</TypographyForms>
                        <TextFieldForms value={formData['id']} id={'gasSupply-id'} name={'id'} />
                      </FormControlDefault>
                    )}
                    <FormControlDefault variant={'outlined'}>
                      <TypographyForms>{translate('fleetSenseApp.gasSupply.volume')}</TypographyForms>
                      <TextFieldForms
                        value={formData['volume']}
                        id={'gasSupply-volume'}
                        data-cy={'volume'}
                        name={'volume'}
                        type={'number'}
                        inputProps={{ min: 0, step: 0.01 }}
                        required={true}
                        onChange={e => handleInputChange('volume', e.target.value)}
                      />
                    </FormControlDefault>
                    <FormControlDefault variant={'outlined'}>
                      <TypographyForms>{translate('fleetSenseApp.gasSupply.price')}</TypographyForms>
                      <TextFieldForms
                        value={formData['price']}
                        id={'gasSupply-price'}
                        data-cy={'price'}
                        name={'price'}
                        type={'number'}
                        inputProps={{ min: 0, step: 0.01 }}
                        required={true}
                        onChange={e => handleInputChange('price', e.target.value)}
                      />
                    </FormControlDefault>
                    <FormControlDefault variant={'outlined'}>
                      <TypographyForms>{translate('fleetSenseApp.gasSupply.distance')}</TypographyForms>
                      <TextFieldForms
                        value={formData['distance']}
                        id={'gasSupply-distance'}
                        data-cy={'distance'}
                        name={'distance'}
                        type={'number'}
                        inputProps={{ min: 0 }}
                        required={true}
                        onChange={e => handleInputChange('distance', e.target.value)}
                      />
                    </FormControlDefault>
                    <ImageInput image={formData['image']} imageContentType={formData['imageContentType']} handleInputChange={handleInputChange}></ImageInput>
                    <RegisterButton />
                  </BoxForm>
                </Box>
              )}
            </Box>
          </Box>
        </RegisterLayout>
      </ThemeProvider>
    </>
  );
};

export default GasSupplyUpdate;
